import axios from "axios";

export default {
  getGalleriFilter: function (baseApiUrl, siteId, siteLang) {
    var response = axios.get(
      baseApiUrl +
        "/Galleri/GalleriFilter?siteId=" +
        siteId +
        "&lang=" +
        siteLang
    );
    return response;
  },
  getGalleriResult: function (
    baseApiUrl,
    query,
    program,
    arskurs,
    projekttyp,
    anpassatAlternativ,
    ar,
    siteId,
    siteLang
  ) {
    var response = axios.post(
      baseApiUrl +
        "/Galleri/GalleriResultat?query=" +
        query +
        "&program=" +
        program +
        "&arskurs=" +
        arskurs +
        "&projekttyp=" +
        projekttyp +
        "&anpassatAlternativ=" +
        anpassatAlternativ +
        "&ar=" +
        ar +
        "&siteId=" +
        siteId +
        "&lang=" +
        siteLang
    );
    return response;
  },
};
